// Generated by scripts/wizbuild.mjs. Edit the matching WIZ view.ts instead.
// @ts-nocheck
import { Component as AngularComponent } from '@angular/core';
import Wiz from '../../wiz';

const wiz = new Wiz({ appId: 'page.operations', namespace: 'operations' });
@AngularComponent({
  selector: 'wiz-page-operations',
  templateUrl: './view.html',
  styleUrls: ['./view.scss'],
  standalone: false
})
export class PageOperationsComponent {}

export default PageOperationsComponent;
